import { createFieldRequirementGetter, matchServerRequirement } from '../../resolverFactory'
import { FieldRequirementResolverContext } from './types'
import {
  FieldRequirement, FieldRequirementEnvironment,
  FieldRequirementResolverMap, forbidden, optional, required,
} from '../../../../../models/fieldRules'

function ruleForPlaceOfAcceptance(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentPlaceOfAcceptance !== false ? 'required' : 'optional'
}

function ruleForPlaceOfAcceptanceFields(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentPlaceOfAcceptance !== false ? 'required' : 'optional'
}

function ruleForPlaceOfDelivery(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentPlaceOfDelivery !== false ? 'required' : 'optional'
}

function ruleForPlaceOfDeliveryFields(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentPlaceOfDelivery !== false ? 'required' : 'optional'
}

function ruleForCountriesOfRouting(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentCountriesOfRouting !== false ? 'required' : 'optional'
}

function ruleForBuyer(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentBuyer !== false ? 'required' : 'forbidden'
}

function ruleForBuyerAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentBuyer !== false ? 'required' : 'optional'
}

function ruleForSeller(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentSeller !== false ? 'required' : 'forbidden'
}

function ruleForSellerAddressPostcode(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  const { ctx } = env

  return ctx.differentSeller !== false ? 'required' : 'optional'
}

const fieldRequirementResolvers: FieldRequirementResolverMap<FieldRequirementResolverContext> = {
  additionalInformation: forbidden,
  additionalReference: forbidden,
  additionalSupplyChainActor: forbidden,
  buyer: ruleForBuyer,
  'buyer.identificationNumber': optional,
  'buyer.address.street': optional,
  'buyer.address.streetNumber': optional,
  'buyer.address.postcode': ruleForBuyerAddressPostcode,
  'buyer.contactPerson': optional,
  containerIndicator: forbidden,
  countriesOfRouting: ruleForCountriesOfRouting,
  departureTransportMeans: optional,
  differentCountriesOfRouting: optional,
  differentBuyer: optional,
  differentPlaceOfAcceptance: optional,
  differentPlaceOfDelivery: optional,
  differentSeller: optional,
  grossMass: required,
  'passiveBorderTransportMeans.*.identificationNumber': optional,
  'passiveBorderTransportMeans.*.typeOfIdentification': optional,
  'passiveBorderTransportMeans.*.typeOfMeansOfTransport': optional,
  'passiveBorderTransportMeans.*.nationality': optional,
  placeOfAcceptance: ruleForPlaceOfAcceptance,
  'placeOfAcceptance.country': ruleForPlaceOfAcceptanceFields,
  'placeOfAcceptance.location': ruleForPlaceOfAcceptanceFields,
  placeOfDelivery: ruleForPlaceOfDelivery,
  'placeOfDelivery.country': ruleForPlaceOfDeliveryFields,
  'placeOfDelivery.location': ruleForPlaceOfDeliveryFields,
  referenceNumberUCR: optional,
  securityIndicatorFromExportDeclaration: forbidden,
  seller: ruleForSeller,
  'seller.identificationNumber': optional,
  'seller.address.street': optional,
  'seller.address.streetNumber': optional,
  'seller.address.postcode': ruleForSellerAddressPostcode,
  'seller.contactPerson': optional,
  'supportingDocument.*.documentType': required,
  'supportingDocument.*.referenceNumber': required,
  transportChargesMethodOfPayment: required,
  'transportDocument.*.complementOfInformation': optional,
  'transportDocument.*.documentLineNumber': optional,
  'transportDocument.*.documentType': required,
  'transportDocument.*.procedureType': optional,
  'transportDocument.*.transportDocumentReferenceNumber': optional,
  transportMeans: optional,
}

function getServerRequirementForPath(
  path: string,
  ctx: FieldRequirementResolverContext,
) {
  return matchServerRequirement(ctx.serverValidationResult?.fieldRequirements, path)
}

const getFieldRequirement = createFieldRequirementGetter<FieldRequirementResolverContext>(
  fieldRequirementResolvers,
  getServerRequirementForPath,
)

export default getFieldRequirement

